export const availableLanguages = ['en', 'pl'];
